<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Business & Accounting
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <el-form :model="form" :rules="rules" label-position="top" size="mini" status-icon ref="form">
            <el-row :gutter="20">
              <el-col :span="8" :offset="0">

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Country For Tax Reporting" prop="countryForTaxRepId">
                      <el-select :disabled="!!form.countryForTaxRepId && isForm" v-model="form.countryForTaxRepId" placeholder="Country For Tax Reporting" clearable filterable style="width: 100%;">
                        <el-option v-for="item in countryForTaxRepList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Formation" prop="businessFormationId">
                      <el-select :disabled="!!form.businessFormationId && isForm" v-model="form.businessFormationId" placeholder="Business Formation" clearable filterable style="width: 100%;">
                        <el-option v-for="item in businessFormationList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Type" prop="businessTypeId">
                      <el-select :disabled="!!form.businessTypeId && form.businessTypeId !== 1 && isForm" v-model="form.businessTypeId" placeholder="Business Type" filterable style="width: 100%;">
                        <el-option v-for="item in businessTypeList"
                          :disabled="(form.businessTypeId && item.id === 3 && isForm) || (form.businessTypeId && item.id === 4 && isForm)"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="form.businessTypeDesc = item.description">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->


                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Type" prop="businessTypeId">
                      <el-select :disabled="!!form.businessTypeId && form.businessTypeId === 4 && isForm" v-model="form.businessTypeId" placeholder="Business Type" filterable style="width: 100%;">
                        <el-option
                          :disabled="(form.businessTypeId && form.businessTypeId === 2 && isForm) || (form.businessTypeId && form.businessTypeId === 3 && isForm) || (form.businessTypeId && form.businessTypeId === 4 && isForm)"
                          :key="1"
                          label="Service"
                          :value="1"
                          @click.native="form.businessTypeDesc = 'You sell Service'"></el-option>
                        <el-option
                          :disabled="(form.businessTypeId && form.businessTypeId === 1 && isForm) || (form.businessTypeId && form.businessTypeId === 3 && isForm) || (form.businessTypeId && form.businessTypeId === 4 && isForm)"
                          :key="2"
                          label="Products"
                          :value="2"
                          @click.native="form.businessTypeDesc = 'You sell Products'"></el-option>
                        <el-option
                          :disabled="(form.businessTypeId && form.businessTypeId === 4 && isForm)"
                          :key="3"
                          label="Service/Products"
                          :value="3"
                          @click.native="form.businessTypeDesc = 'Purchasing and sell goods and items'"></el-option>
                        <el-option
                          :key="4"
                          label="Manufacturing"
                          :value="4"
                          @click.native="form.businessTypeDesc = 'You manufacture and sell a goods'"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>


                <el-row :gutter="20" v-if="form.businessTypeId">
                  <el-col :span="24" :offset="0">
                    <el-form-item prop="businessTypeDesc">
                      <el-input disabled label="" v-model="form.businessTypeDesc"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Method of Accounting" prop="methodOfAccountingId">
                      <el-select :disabled="form.methodOfAccountingId && form.methodOfAccountingId === 2 && isForm" v-model="form.methodOfAccountingId" placeholder="Method of Accounting" filterable style="width: 100%;">
                        <el-option v-for="item in methodOfAccountingList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="form.methodOfAccountingDesc = item.description">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-if="form.methodOfAccountingId">
                  <el-col :span="24" :offset="0">
                    <el-form-item prop="methodOfAccountingDesc">
                      <el-input disabled label="" v-model="form.methodOfAccountingDesc"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Accounting Currency (Use Home Currency?)" prop="accountingCurrencyHomeId">
                      <el-select :disabled="!!form.accountingCurrencyHomeId && isForm" v-model="form.accountingCurrencyHomeId" placeholder="Accounting Currency (Use Home Currency?)" clearable filterable style="width: 100%;">
                        <el-option v-for="item in accountingCurrencyHomeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Select Accounting Base Currency" prop="currencyId">
                      <el-select :disabled="!!form.currencyId && isForm" v-model="form.currencyId" placeholder="Select Accounting Base Currency" clearable filterable style="width: 100%;">
                        <el-option v-for="item in currencyList"
                          :key="item.id"
                          :label="item.code"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-if="form.businessTypeId !== 1">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Inventory Valuation Method" prop="inventoryValuationMethodId">
                      <el-select v-model="form.inventoryValuationMethodId" placeholder="Inventory Valuation Method" clearable filterable style="width: 100%;">
                        <el-option v-for="item in inventoryValuationMethodList"
                          :disabled="item.id === 3 || item.id === 1"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Depreciation Method" prop="depreciationMethodId">
                      <el-select v-model="form.depreciationMethodId" placeholder="Depreciation Method" clearable filterable style="width: 100%;">
                        <el-option v-for="item in depreciationMethodList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Financial Year Time Period" prop="financialYearTimePeriodId">
                      <el-select v-model="form.financialYearTimePeriodId" placeholder="Financial Year Time Period" clearable filterable style="width: 100%;">
                        <el-option v-for="item in financialYearTimePeriodList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setYear(item.id)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Financial Year Start Date" prop="financialYearStartDate">
                      <el-date-picker
                        :disabled="form.financialYearTimePeriodId == 2"
                        style="width: 100%;"
                        v-model="form.financialYearStartDate"
                        :clearable='true'
                        format="d MMM yy"
                        value-format="MM-dd-yyyy"
                        type="date"
                        placeholder="Financial Year Start Date">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Employs People" prop="businessEmploysPeopleId">
                      <el-select v-model="form.businessEmploysPeopleId" placeholder="Business Employs People" clearable filterable style="width: 100%;">
                        <el-option v-for="item in businessEmploysPeopleList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="selectBusinessEmploysPeople(item)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-if="form.businessEmploysPeopleId === 1">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Do you want to add a Payroll Journal?" prop="payrollJournalId">
                      <el-select v-model="form.payrollJournalId" placeholder="Do you want to add a Payroll Journal?" clearable filterable style="width: 100%;">
                        <el-option v-for="item in payrollJournalList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-col>
              <el-col :span="8" :offset="0">

                <!-- <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Business Formation" prop="businessFormationId">
                      <el-select :disabled="!!form.businessFormationId && isForm" v-model="form.businessFormationId" placeholder="Business Formation" clearable filterable style="width: 100%;">
                        <el-option v-for="item in businessFormationList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->

                <el-row :gutter="20" v-if="isForm">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Default Chart of Accounts">
                      <!-- <el-select disabled v-model="form.businessFormationId" placeholder="Business Formation" clearable filterable style="width: 100%;">
                        <el-option v-for="item in businessFormationList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select> -->

                      {{businessTypeName}} / {{methodOfAccountingName}} / {{businessFormationName}}
                    </el-form-item>
                  </el-col>
                </el-row>

                <h5>Journals Used</h5>

                <div class="used">
                  <div>SJ - Sales Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>PJ - Purchase Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>CR - Cash Receipts Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2 || form.methodOfAccountingId === 1" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>CD - Cash Disbursements Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2 || form.methodOfAccountingId === 1" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>SR - Sales Returns Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2 && form.countryForTaxRepId !== 103" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>PR - Purchase Returns Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2 && form.countryForTaxRepId !== 103" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>GJ - General Journal</div>
                  <div>
                    <el-tag v-if="form.methodOfAccountingId === 2 || form.methodOfAccountingId === 1" type="success" style="width: 70px; text-align: center;">Active</el-tag>
                    <el-tag v-else type="danger" style="width: 70px; text-align: center;">Inactive</el-tag>
                  </div>
                </div>

                <div class="used">
                  <div>PR - Payroll Journal</div>
                  <div><el-tag :type="form.payrollJournalId === 1 ? 'success' : 'danger'" style="width: 70px; text-align: center;">{{form.payrollJournalId === 1 ? 'Active' : 'Inactive'}}</el-tag></div>
                </div>


                <div class="xero" style="margin-top: 50px;">
                  <el-checkbox v-model="form.isXero">Connect with Xero</el-checkbox>
                  <div class="inputs" style="margin-top: 20px; display:flex; gap: 10px; flex-direction: column;">
                    <el-input class="used" label="APi Key" :disabled="!form.isXero" v-model="form.xeroTenantId" size="mini"></el-input>
                    <el-input class="used" label="APi Secret" :disabled="!form.isXero" v-model="form.idempotencyKey" size="mini"></el-input>
                    <div style="font-size: 12px;">Info how to get API key and password from Xero.com?</div>
                  </div>
                </div>

                <div>
                  <h4>Accounting Periods</h4>
                  <p v-for="item in periodArr" :key="item.period">{{ item.text }}</p>
                </div>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Lock accounting period to" prop="lockAccountingPeriodTo">
                      <el-date-picker
                        :disabled="!companyLayout.permission.setAccountingPeriodLockDate"
                        style="width: 100%;"
                        v-model="form.lockAccountingPeriodTo"
                        format="d MMM yy"
                        value-format="timestamp"
                        type="date"
                        :clearable='false'
                        placeholder="Lock accounting period to"
                        :picker-options="pickerOptions2">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="8" :offset="0">

                <el-alert
                  title="As shown in the Certificate of Registration (COR)"
                  type="warning"
                  style="margin-bottom: 20px;"
                  show-icon>
                </el-alert>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="" prop="isAddress">
                      <el-switch :disabled="true" v-model="form.isAddress" active-text="Registered Office Address">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>

                <template v-if="form.isAddress">
                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Country" prop="countryId">
                        <el-select no-data-text="no data" v-model="form.countryId" @visible-change="loadCountryList" :placeholder="$t('modal_country')" filterable style="width: 100%;">
                          <el-option
                            v-for="item in countryList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setState('main', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="State / Province / Country" prop="stateId">
                        <el-select no-data-text="no data" v-model="form.stateId" @visible-change="loadStateList" :placeholder="$t('modal_state')" filterable style="width: 100%;">
                          <el-option
                            v-for="item in stateList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            @click.native="setCity('main', item)">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="City" prop="cityId">
                        <el-select no-data-text="no data" v-model="form.cityId" @visible-change="loadCityList" :placeholder="$t('modal_city')" filterable style="width: 100%;">
                          <el-option
                            v-for="item in cityList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Post Code" prop="postCode">
                        <el-input v-model="form.postCode" placeholder="Post Code"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Barangay" prop="barangay">
                        <el-input v-model="form.barangay" placeholder="Barangay"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Address Line 1" prop="address">
                        <el-input v-model="form.address" placeholder="Address Line 1"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Address Line 2" prop="address2">
                        <el-input v-model="form.address2" placeholder="Address Line 2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Address Line 3" prop="address3">
                        <el-input v-model="form.address3" placeholder="Address Line 3"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>

              </el-col>
            </el-row>

            <el-form-item>
              <el-button @click="save('form')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'settingAccounting',
  created() {
    this.directories()
    // this.getAccounting()
  },
  data() {
    return {
      moment: moment,

      businessTypeName: null,
      methodOfAccountingName: null,
      businessFormationName: null,

      countryForTaxRepList: [],
      currencyList: [],
      businessTypeList: [],
      businessFormationList: [],
      methodOfAccountingList: [{id: 1, name: 'Cash', description: 'Tax Reporting Country Home Currency'}, {id: 2, name: 'Accrual', description: 'Tax Reporting Country Home Currency'}],
      accountingCurrencyHomeList: [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}],
      inventoryValuationMethodList: [{id: 2, name: 'First In/First Out (FIFO)'}, {id: 3, name: 'Last In/First Out (LIFO)'}, {id: 1, name: ' Weighted Average (AVCO)'}],
      depreciationMethodList: [{id: 1, name: 'Straight Line'}],
      financialYearTimePeriodList: [{id: 1, name: ' Fiscal Year'}, {id: 2, name: 'Calendar Year'}],
      businessEmploysPeopleList: [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}],
      payrollJournalList: [{id: 1, name: 'Yes'}, {id: 2, name: 'No'}],

      countryList: [],
      stateList: [],
      cityList: [],

      isForm: false,
      selectedBusinessTypeId: null,
      form: {
        countryForTaxRepId: null,
        businessTypeId: null,
        businessTypeDesc: '',
        methodOfAccountingId: null,
        methodOfAccountingDesc: '',
        accountingCurrencyHomeId: null,
        currencyId: null,
        inventoryValuationMethodId: null,
        depreciationMethodId: null,
        financialYearTimePeriodId: null,
        financialYearStartDate: null,
        businessEmploysPeopleId: null,
        payrollJournalId: null,
        businessFormationId: null,

        isAddress: true,
        countryId: null,
        stateId: null,
        cityId: null,
        postCode: '',
        barangay: '',
        address: '',
        address2: '',
        address3: '',

        isXero: false,
        xeroTenantId: null,
        idempotencyKey: null,

        lockAccountingPeriodTo: null,
      },

      periodArr: [],
      pickerOptions2: {
        disabledDate: this.disabledDate,
      },

      rules: {
        countryForTaxRepId: [
          { required: true, message: 'Please select Country For Tax Reporting', trigger: 'change' }
        ],
        businessTypeId: [
          { required: true, message: 'Please select Business Type', trigger: 'change' }
        ],
        methodOfAccountingId: [
          { required: true, message: 'Please select Method of Accounting', trigger: 'change' }
        ],
        accountingCurrencyHomeId: [
          { required: true, message: 'Please select Accounting Currency', trigger: 'change' }
        ],
        inventoryValuationMethodId: [
          { required: true, message: 'Please select Inventory Valuation Method', trigger: 'change' }
        ],
        depreciationMethodId: [
          { required: true, message: 'Please select Depreciation Method', trigger: 'change' }
        ],
        financialYearTimePeriodId: [
          { required: true, message: 'Please select Financial Year Time Period', trigger: 'change' }
        ],
        financialYearStartDate: [
          { required: true, message: 'Please select Financial Year Start Date', trigger: 'change' }
        ],
        // lockAccountingPeriodTo: [
        //   { required: true, message: 'Please select Lock accounting period to', trigger: 'change' }
        // ],
        businessEmploysPeopleId: [
          { required: true, message: 'Please select Business Employs People', trigger: 'change' }
        ],
        payrollJournalId: [
          { required: true, message: 'Please select Payroll Journal', trigger: 'change' }
        ],
        currencyId: [
          { required: true, message: 'Please select Accounting Base Currency', trigger: 'change' }
        ],
        businessFormationId: [
          { required: true, message: 'Please select Business Formation', trigger: 'change' }
        ],
        countryId: [
          { required: true, message: 'Please select Country', trigger: 'change' }
        ],
        stateId: [
          { required: true, message: 'Please select State', trigger: 'change' }
        ],
        cityId: [
          { required: true, message: 'Please select City', trigger: 'change' }
        ],
      }
    }
  },
  computed: {
    companyLayout() {
      return this.$store.state.companyLayout
    },
  },
  // watch: {
  //   'form.isAddress': function (val) {
  //     if (!val) {
  //       this.form.isAddress = false
  //       this.form.countryId = null
  //       this.form.stateId = null
  //       this.form.cityId = null
  //       this.form.postCode = ''
  //       this.form.address = ''
  //       this.form.address2 = ''
  //       this.form.address3 = ''
  //     }
  //   }
  // },
  methods:{
    disabledDate(date) {
      if (this.companyLayout.lockAccountingPeriodTo) {
        const loc = new Date(this.companyLayout.lockAccountingPeriodTo)
        loc.setHours(0, 0, 0, 0)

        const selectedDate = new Date(date)
        return selectedDate.getTime() <= loc.getTime()
      }
    },
    handleDateChange(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Устанавливаем время в 00:00:00
      return date.getTime() < today.getTime(); // Блокируем даты до сегодняшнего дня
    },
    setYear(id) {
      this.form.financialYearStartDate = moment().startOf('year').format('DD-MM-YYYY')
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    selectBusinessEmploysPeople(item) {
      if (item.id === 2) {
        this.form.payrollJournalId = null
      }
    },
    directories() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/companies/directories?companyId=${this.$route.query.companyId}&operation=update`)
        .then(response => {
          this.countryForTaxRepList = response.data.countryList
          this.businessTypeList = response.data.businessType
          this.businessFormationList = response.data.businessFormation
          this.currencyList = response.data.currencyList
          this.getAccounting()
        })
        .catch(error => {
          console.log('An error occurred:', error);
        });
    },
    getAccounting(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/company-accounting-and-business-info/item?companyId=${this.$route.query.companyId}`)
        .then(response => {
          this.isForm = !!response.data.item
          if (this.isForm) {
            this.businessTypeName = this.businessTypeList.find(item => item.id === response.data.item.businessTypeId).name
            this.methodOfAccountingName = this.methodOfAccountingList.find(item => item.id === response.data.item.methodOfAccountingId).name
            this.businessFormationName = this.businessFormationList.find(item => item.id === response.data.item.businessFormationId).name
          }
          this.selectedBusinessTypeId = response.data.item.businessTypeId
          this.form.countryForTaxRepId = response.data.item.countryForTaxRepId
          this.form.businessTypeId = response.data.item.businessTypeId
          this.form.businessTypeDesc = response.data.item.businessTypeDesc
          this.form.methodOfAccountingId = response.data.item.methodOfAccountingId
          this.form.methodOfAccountingDesc = response.data.item.methodOfAccountingDesc
          this.form.accountingCurrencyHomeId = response.data.item.accountingCurrencyHomeId
          this.form.currencyId = response.data.item.currencyId
          this.form.inventoryValuationMethodId = response.data.item.inventoryValuationMethodId
          this.form.depreciationMethodId = response.data.item.depreciationMethodId
          this.form.financialYearTimePeriodId = response.data.item.financialYearTimePeriodId
          this.form.financialYearStartDate = response.data.item.financialYearStartDate
          this.form.businessEmploysPeopleId = response.data.item.businessEmploysPeopleId
          this.form.payrollJournalId = response.data.item.payrollJournalId
          this.form.businessFormationId = response.data.item.businessFormationId

          this.form.lockAccountingPeriodTo = response.data.item.lockAccountingPeriodTo || null

          // !ALERT false -> true
          this.form.isAddress = response.data.item.isAddress ? response.data.item.isAddress : true

          if (this.form.isAddress && response.data.item.country && response.data.item.state && response.data.item.city) {
            this.countryList.push(response.data.item.country)
            this.stateList.push(response.data.item.state)
            this.cityList.push(response.data.item.city)
            this.form.countryId = response.data.item.countryId
            this.form.stateId = response.data.item.stateId
            this.form.cityId = response.data.item.cityId
            this.form.postCode = response.data.item.postCode
            this.form.barangay = response.data.item.barangay
            this.form.address = response.data.item.address
            this.form.address2 = response.data.item.address2
            this.form.address3 = response.data.item.address3
          }

          if (response.data.item.xeroTenantId && response.data.item.idempotencyKey) {
            this.form.isXero = true
          }
          this.form.idempotencyKey = response.data.item.idempotencyKey
          this.form.xeroTenantId = response.data.item.xeroTenantId

          this.periodArr = response.data.item.periodArr
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    save(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          if (this.form.businessTypeId === 1) { this.form.inventoryValuationMethodId = null }
          if (!this.isForm || this.selectedBusinessTypeId !== this.form.businessTypeId) {
            this.$confirm('Attention, make sure that the information filling is correct. After saving the form, a Chart of Accounts will be created. This operation is not reversible. Continue?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'info'
            }).then(() => {
              let loader = this.$loading.show();
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/company-accounting-and-business-info/save?companyId=${this.$route.query.companyId}`, this.form)
                .then(response => {
                  this.$message({
                    type: 'success',
                    message: 'Save'
                  });
                  this.getAccounting()
                  // if (!this.isForm) {
                  //   this.createTree()
                  // } else {
                  //   if (this.selectedBusinessTypeId !== this.form.businessTypeId) { this.createTreeServiceRetail() }
                  // }
                  this.$store.dispatch('getCompanyLayout')
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: 'Save canceled'
              });
            });
          } else {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/company-accounting-and-business-info/save?companyId=${this.$route.query.companyId}`, this.form)
              .then(response => {
                this.$message({
                  type: 'success',
                  message: 'Save'
                });
                this.getAccounting()
                // if (!this.isForm) {
                //   this.createTree()
                // } else {
                //   if (this.selectedBusinessTypeId !== this.form.businessTypeId) { this.createTreeServiceRetail() }
                // }
                this.$store.dispatch('getCompanyLayout')
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          }
        }
      });
    },
    // createTree() {
    //   let loader = this.$loading.show();
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //   axios
    //     .post(`/api/v1/company/chart-of-account/create-tree?companyId=${this.$route.query.companyId}`)
    //     .then(response => {
    //       loader.hide()
    //     })
    //     .catch(error => {
    //       console.log('An error occurred:', error);
    //       loader.hide()
    //     });
    // },
    // createTreeServiceRetail() {
    //   let loader = this.$loading.show();
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    //   axios
    //     .post(`/api/v1/company/chart-of-account/add?companyId=${this.$route.query.companyId}`)
    //     .then(response => {
    //       loader.hide()
    //     })
    //     .catch(error => {
    //       console.log('An error occurred:', error);
    //       loader.hide()
    //     });
    // },
    loadList(type, id, arrType) {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/country/directories?type=${type}&id=${id}`)
        .then(response => {
          this[arrType] = response.data.list
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    // Address
    loadCountryList(isVisiable) {
      if (isVisiable && this.countryList.length < 2) {
        this.loadList('country', null, 'countryList')
      }
    },
    loadStateList(isVisiable) {
      if (isVisiable && this.stateList.length < 2) {
        this.loadList('state', this.form.countryId, 'stateList')
      }
    },
    loadCityList(isVisiable) {
      if (isVisiable && this.cityList.length < 2) {
        this.loadList('city', this.form.stateId, 'cityList')
      }
    },
    setState(type, item) {
      if (type === 'main') {
        this.form.stateId = null;
        this.form.cityId = null;
        this.stateList = []
        this.cityList = []
      }
    },
    setCity(type, item) {
      if (type === 'main') {
        this.form.cityId = null
        this.cityList = []
      }
    },
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper {
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

/deep/.el-form-item__label {
  color: #000;
  font-weight: bold;
  padding: 0;
}

.used {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
</style>
